import { composeAction } from '@gef-ui/redux-common/utils';
import { createAction } from '@gef-ui/utils/fsaActions';
import identity from "ramda/es/identity";
import { fieldActions } from '../../constants';
export const registerField = (formName)=>createAction(composeAction(formName, fieldActions.REGISTER_FIELD), identity);
export const unregisterField = (formName)=>createAction(composeAction(formName, fieldActions.UNREGISTER_FIELD), identity);
